import { jsx as _jsx } from "react/jsx-runtime";
import { ModuleFE_Variable } from '../_entity/variable/index.js';
import { ModuleFE_Value } from '../_entity/value/index.js';
import { Renderer_SearchResult, SearchItemV3_With_ID } from '@app/styles';
import { Component_HealthcareSpace } from './healthcare-space/index.js';
import { resolveValueDisplay } from '@app/hcs-shared';
import { Manager_HealthcareSpace } from './Manager_HealthcareSpace/Manager_HealthcareSpace.js';
import { ErrorPage_Values } from './ErrorPage_Values/ErrorPage_Values.js';
import { ConfigKeyFE_SourceTagId, ModuleFE_Discussion, ModuleFE_Tag } from '../_entity.js';
import { CollectionEntityMapper } from '../entities/CollectionEntityMapper.js';
export const searchItemKey_Variables = ModuleFE_Variable.dbDef.dbKey;
export const searchItemKey_Tags = ModuleFE_Tag.dbDef.dbKey;
export const searchItemKey_Values = ModuleFE_Value.dbDef.dbKey;
export const SearchableItem_Tags = SearchItemV3_With_ID({
    module: ModuleFE_Tag,
    type: searchItemKey_Tags,
    route: Component_HealthcareSpace.Route,
    entityName: ModuleFE_Tag.dbDef.dbKey,
    entityLabel: 'Tag',
    groupId: ['Healthcare Space'],
    mapper: (item) => [item.label],
    renderer: (item, selected, onClickCallback) => {
        let hierarchy = 'Healthcare Space';
        item.tagIds.forEach(tagId => {
            const tag = ModuleFE_Tag.cache.unique(tagId);
            hierarchy += ` > ${tag.label}`;
        });
        return _jsx(Renderer_SearchResult, { itemId: item._id, itemKey: searchItemKey_Tags, itemLabel: item.label, entityLabel: 'Tag', hierarchy: hierarchy, selected: selected, onClickCallback: onClickCallback });
    },
    resultRenderer: (itemId) => {
        return _jsx(Manager_HealthcareSpace, { tagId: itemId });
    },
    tags: [],
});
export const SearchableItem_Variables = SearchItemV3_With_ID({
    module: ModuleFE_Variable,
    type: searchItemKey_Variables,
    route: Component_HealthcareSpace.Route,
    entityName: ModuleFE_Variable.dbDef.entityName,
    entityLabel: 'Variable',
    groupId: ['Healthcare Space'],
    mapper: (item) => [item.name],
    renderer: (item, selected, onClickCallback) => {
        let hierarchy = 'Healthcare Space';
        item.tagIds.find(tagGroup => tagGroup.key === ConfigKeyFE_SourceTagId.get())?.value.forEach(tagId => {
            const tag = ModuleFE_Tag.cache.unique(tagId);
            if (!tag)
                return;
            hierarchy += ` > ${tag.label}`;
        });
        return _jsx(Renderer_SearchResult, { itemId: item._id, itemKey: searchItemKey_Variables, itemLabel: item.name, entityLabel: 'Variable', hierarchy: hierarchy, selected: selected, onClickCallback: onClickCallback, className: ModuleFE_Discussion.hasUnresolvedDiscussions(item._id, ModuleFE_Variable.dbDef.dbKey) ? 'open-discussion' : undefined });
    },
    resultRenderer: (itemId) => {
        const variable = ModuleFE_Variable.cache.unique(itemId);
        const id = variable.tagIds.find(group => group.key === ConfigKeyFE_SourceTagId.get()).value[0];
        return _jsx(Manager_HealthcareSpace, { tagId: id, varId: itemId });
    },
    tags: [],
});
export const SearchableItem_Values = SearchItemV3_With_ID({
    module: ModuleFE_Value,
    type: searchItemKey_Values,
    route: Component_HealthcareSpace.Route,
    entityName: ModuleFE_Value.dbDef.dbKey,
    entityLabel: 'Value',
    groupId: ['Healthcare Space'],
    mapper: (item) => [resolveValueDisplay(item)],
    renderer: (item, selected, onClickCallback) => {
        let hierarchy = 'Healthcare Space';
        let error = false;
        try {
            const variableId = ModuleFE_Variable.getVariableIdForValueId(item._id);
            const variable = ModuleFE_Variable.cache.unique(variableId);
            variable.tagIds.find(tagGroup => tagGroup.key === ConfigKeyFE_SourceTagId.get())?.value.forEach(tagId => {
                const tag = ModuleFE_Tag.cache.unique(tagId);
                if (!tag)
                    return;
                hierarchy += ` > ${tag.label}`;
            });
            hierarchy += ` > ${variable.name}`;
        }
        catch (err) {
            error = true;
        }
        return _jsx(Renderer_SearchResult, { itemId: item._id, itemKey: searchItemKey_Values, itemLabel: resolveValueDisplay(item) ?? item._id, entityLabel: 'Value', hierarchy: hierarchy, selected: selected, onClickCallback: onClickCallback, error: error });
    },
    resultRenderer: (item) => {
        try {
            const variableId = ModuleFE_Variable.getVariableIdForValueId(item);
            const variable = ModuleFE_Variable.cache.unique(variableId);
            const tagId = variable.tagIds.find(group => group.key === ConfigKeyFE_SourceTagId.get()).value[0];
            return _jsx(Manager_HealthcareSpace, { tagId: tagId, varId: variableId });
        }
        catch (err) {
            return _jsx(ErrorPage_Values, { valueId: item, error: err });
        }
    },
    tags: [],
});
CollectionEntityMapper.addEntities([
    SearchableItem_Variables,
    SearchableItem_Values,
    SearchableItem_Tags,
]);
//# sourceMappingURL=search-items.js.map